import { Box } from "@chakra-ui/react";
import { BidV2Status, type BidV2Dto } from "../../../../autogen/bff-api";
import { PreviousSigningBreadcrumb } from "./PreviousSigningBreadcrumb";
import { SigningPill } from "./SigningPill";

export const BidSigningHeaderBadge = ({ bid }: { bid: BidV2Dto }) => {
  if (bid.signedDocumentId != null && bid.status === BidV2Status.Draft) {
    return (
      <Box mt="2">
        <SigningPill />
      </Box>
    );
  }
  if (bid.signedDocumentId == null && bid.previousSigningOutcome) {
    return <PreviousSigningBreadcrumb outcome={bid.previousSigningOutcome} />;
  }
  return null;
};
